import { Field, Honeypot, SubmitButton, SuccessPanel, inputCls, useEnquiry } from "@/components/forms/fields";

export default function WarrantyForm() {
  const { data, set, errors, status, submit, reset, formProps } = useEnquiry(
    "warranty",
    ["first_name", "last_name", "phone", "email", "address", "issue"],
    "/warranty"
  );

  if (status === "success")
    return (
      <SuccessPanel
        testid="warranty-form-success"
        title="Thank you. Your warranty enquiry has been submitted."
        message="Our team will contact you after reviewing the information you have provided."
        onReset={reset}
      />
    );

  return (
    <form onSubmit={submit} {...formProps} noValidate data-testid="warranty-form" className="space-y-5">
      <Honeypot value={data.website || ""} onChange={(v) => set("website", v)} />
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="First Name" required error={errors.first_name}>
          <input data-testid="warranty-first-name" className={inputCls} value={data.first_name || ""} onChange={(e) => set("first_name", e.target.value)} autoComplete="given-name" />
        </Field>
        <Field label="Last Name" required error={errors.last_name}>
          <input data-testid="warranty-last-name" className={inputCls} value={data.last_name || ""} onChange={(e) => set("last_name", e.target.value)} autoComplete="family-name" />
        </Field>
        <Field label="Phone" required error={errors.phone}>
          <input data-testid="warranty-phone" type="tel" className={inputCls} value={data.phone || ""} onChange={(e) => set("phone", e.target.value)} autoComplete="tel" />
        </Field>
        <Field label="Email" required error={errors.email}>
          <input data-testid="warranty-email" type="email" className={inputCls} value={data.email || ""} onChange={(e) => set("email", e.target.value)} autoComplete="email" />
        </Field>
      </div>
      <Field label="Installation Address" required error={errors.address}>
        <input data-testid="warranty-address" className={inputCls} value={data.address || ""} onChange={(e) => set("address", e.target.value)} autoComplete="street-address" />
      </Field>
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Installation Date">
          <input data-testid="warranty-installation-date" type="date" className={inputCls} value={data.installation_date || ""} onChange={(e) => set("installation_date", e.target.value)} />
        </Field>
        <Field label="Brand">
          <input data-testid="warranty-brand" className={inputCls} value={data.brand || ""} onChange={(e) => set("brand", e.target.value)} />
        </Field>
        <Field label="Model Number">
          <input data-testid="warranty-model" className={inputCls} value={data.model_number || ""} onChange={(e) => set("model_number", e.target.value)} />
        </Field>
        <Field label="Serial Number">
          <input data-testid="warranty-serial" className={inputCls} value={data.serial_number || ""} onChange={(e) => set("serial_number", e.target.value)} />
        </Field>
      </div>
      <Field label="Invoice Number">
        <input data-testid="warranty-invoice" className={inputCls} value={data.invoice_number || ""} onChange={(e) => set("invoice_number", e.target.value)} />
      </Field>
      <Field label="Description of Issue" required error={errors.issue}>
        <textarea data-testid="warranty-issue" rows={5} className={inputCls} value={data.issue || ""} onChange={(e) => set("issue", e.target.value)} placeholder="Describe the issue you're experiencing with your system…" />
      </Field>
      <SubmitButton status={status} testid="warranty-submit-btn">Submit Warranty Enquiry</SubmitButton>
    </form>
  );
}
